import React, { useState } from "react";

type BoxButtonProps = {
  imageSrc: string;
  text: string;
  handleClick: () => void;
  isActive: boolean;
};

const BoxButton: React.FC<BoxButtonProps> = ({
  imageSrc,
  text,
  handleClick,
  isActive,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const notHovered = () => {
    setIsHovered(false);
  };

  const hovered = () => {
    setIsHovered(true);
  };

  return (
    <button
      className={`flex flex-col items-center justify-center rounded-md p-4 text-white transition-colors duration-300 lg:p-6 xl:p-8 ${
        isActive ? "industry-box-selected" : "industry-box"
      }`}
      onClick={handleClick}
      onMouseEnter={hovered}
      onMouseLeave={notHovered}
    >
      <img
        src={imageSrc}
        alt={text}
        className={`lg:w-18 lg:h-18 mb-2 h-12 w-12 2xl:h-24 2xl:w-24 ${
          isActive || isHovered ? "industry-img-selected" : "industry-img"
        }`}
      />
      <span className="text-lg font-bold">{text}</span>
    </button>
  );
};

export default BoxButton;
